import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { LandingPage } from '@/areas/settings/manufacturing/Settings/LandingPage/LandingPage';
import { canViewCustomerPortalSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/customer-portal/landing-page')({
    staticData: {
        access: { permissions: canViewCustomerPortalSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <LandingPage />;
}
